import styled from 'styled-components';

import InfoCircleIconSvg from '../../../assets/icons/icon-info-circle.svg?react';
import { BaseButton } from '../../../shared/ui';

type MyPageProfileGoalTipToggleButtonProps = {
  ariaLabel: string;
  onPress: () => void;
};

const Button = styled(BaseButton).attrs({
  'data-ui': 'my-page-profile-goal-tip-toggle-button',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(12)};
  box-sizing: border-box;
  display: grid;
  place-items: center;
`;

const Icon = styled(InfoCircleIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: 100%;
  height: 100%;
  --stroke-0: ${({ theme }) => theme.colors.text.primary};
`;

export function MyPageProfileGoalTipToggleButton({
  ariaLabel,
  onPress,
}: MyPageProfileGoalTipToggleButtonProps) {
  return (
    <Button type="button" aria-label={ariaLabel} onClick={onPress}>
      <Icon />
    </Button>
  );
}
